import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { useId, useRef, type FC } from "react";

export const WebStormLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.22286 21.7029L0 2.50287L6 0.0343018L9.80571 2.29716L13.3029 0.411446L20.6057 3.22287L16.4914 24L3.22286 21.7029Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path
                d="M24 8.12572L20.9143 0.48L15.2914 0L6.61714 8.33143L8.94857 19.0629L13.3029 22.1486L24 15.7714L21.36 10.8686L24 8.12572Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M19.2 6.99427L21.36 10.8686L24 8.1257L22.08 3.35999L19.2 6.99427Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path d="M4.59428 4.59424H19.4057V19.4057H4.59428V4.59424Z" fill="black" />
            <path d="M6 16.6285H11.5543V17.5543H6V16.6285Z" fill="white" />
            <path
                d="M13.2686 11.76L14.0571 10.8C14.5549 11.258 15.1985 11.5252 15.8743 11.5543C16.4229 11.5543 16.7314 11.3486 16.7314 10.9714V10.9371C16.7314 10.5943 16.5257 10.4229 15.4971 10.1486C14.2629 9.84 13.5086 9.49714 13.5086 8.26286V8.22857C13.5086 7.09714 14.4 6.37714 15.6343 6.37714C16.4589 6.35933 17.2622 6.63929 17.8971 7.16572L17.2114 8.19428C16.7597 7.83467 16.2101 7.61959 15.6343 7.57714C15.12 7.57714 14.8457 7.81714 14.8457 8.12572V8.16C14.8457 8.57143 15.12 8.70857 16.1486 8.98286C17.3829 9.32572 18.0686 9.77143 18.0686 10.8343V10.8686C18.0686 12.1029 17.1429 12.7886 15.84 12.7886C14.8888 12.7578 13.9786 12.3938 13.2686 11.76Z"
                fill="white"
            />
            <path
                d="M12.0686 6.51428L11.1429 10.08L10.1143 6.51428H9.08572L8.02286 10.08L7.09715 6.51428H5.69143L7.44 12.6514H8.57143L9.6 9.08571L10.5943 12.6514H11.76L13.5086 6.51429L12.0686 6.51428Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="8.59171"
                    y1="0.50143"
                    x2="14.8026"
                    y2="22.8609"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.285" stopColor="#00CDD7" />
                    <stop offset="0.941" stopColor="#2086D7" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="10.5402"
                    y1="3.3322"
                    x2="21.047"
                    y2="18.7392"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.14" stopColor="#FFF045" />
                    <stop offset="0.366" stopColor="#00CDD7" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="20.9455"
                    y1="5.24141"
                    x2="22.3251"
                    y2="10.1285"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.285" stopColor="#00CDD7" />
                    <stop offset="0.941" stopColor="#2086D7" />
                </linearGradient>
            </defs>
        </svg>
    );
};
